import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("i", { class: "pi pi-chevron-left mr-1" }, null, -1)
const _hoisted_2 = { class: "mt-2" }
const _hoisted_3 = { class: "position-relative scenes-tabview" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Scene = _resolveComponent("Scene")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_TabView = _resolveComponent("TabView")
  const _component_Button = _resolveComponent("Button")
  const _component_DialogConfirmDeleteScene = _resolveComponent("DialogConfirmDeleteScene")
  const _component_DialogConfirmDisableScene = _resolveComponent("DialogConfirmDisableScene")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", null, [
      _createVNode("div", null, [
        _createVNode(_component_router_link, {
          to: _ctx.backLink,
          class: "fs-18 text-decoration-none text-gray"
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("general.backTo")) + ": " + _toDisplayString(_ctx.currentPlant.name), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("AppResource.Scenes")), 1)
      ])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_TabView, {
        "active-index": 0,
        class: "p-tabview--custom position-relative",
        onTabChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleTabClick($event)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, {
            header: _ctx.$t('AppResource.All')
          }, {
            default: _withCtx(() => [
              (_ctx.scenes.length > 0 && _ctx.activeTabIndex == 0)
                ? (_openBlock(), _createBlock(_component_ElScrollbar, {
                    key: 0,
                    class: "scenes-card-list"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scenes, (s, i) => {
                        return (_openBlock(), _createBlock(_component_Scene, {
                          scene: s,
                          key: `scene-${i}`,
                          onEdit: ($event: any) => (_ctx.handleEditScene(s)),
                          onDelete: ($event: any) => (_ctx.toggleDeleteConfirm(s)),
                          onDisable: ($event: any) => (_ctx.toggleDisableConfirm(s)),
                          onDuplicate: ($event: any) => (_ctx.handleDuplicateScene(s)),
                          onEnable: ($event: any) => (_ctx.handleToggleEnabledScene(s)),
                          "disable-actions": !_ctx.scenesActionsEnabled
                        }, null, 8, ["scene", "onEdit", "onDelete", "onDisable", "onDuplicate", "onEnable", "disable-actions"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_TabPanel, {
            header: _ctx.$t('AppResource.Custom')
          }, {
            default: _withCtx(() => [
              (_ctx.sceneCategories.customScenes.length > 0 && _ctx.activeTabIndex == 1)
                ? (_openBlock(), _createBlock(_component_ElScrollbar, {
                    key: 0,
                    class: "scene-card-list"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sceneCategories.customScenes, (s, i) => {
                        return (_openBlock(), _createBlock(_component_Scene, {
                          scene: s,
                          key: `custom-scene-${i}`,
                          onEdit: ($event: any) => (_ctx.handleEditScene(s)),
                          onDelete: ($event: any) => (_ctx.toggleDeleteConfirm(s)),
                          onDisable: ($event: any) => (_ctx.toggleDisableConfirm(s)),
                          onDuplicate: ($event: any) => (_ctx.handleDuplicateScene(s)),
                          onEnable: ($event: any) => (_ctx.handleToggleEnabledScene(s)),
                          "disable-actions": !_ctx.scenesActionsEnabled
                        }, null, 8, ["scene", "onEdit", "onDelete", "onDisable", "onDuplicate", "onEnable", "disable-actions"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_TabPanel, {
            header: _ctx.$t('AppResource.Default')
          }, {
            default: _withCtx(() => [
              (_ctx.sceneCategories.defaultScenes.length > 0 && _ctx.activeTabIndex == 2)
                ? (_openBlock(), _createBlock(_component_ElScrollbar, {
                    key: 0,
                    class: "scene-card-list"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sceneCategories.defaultScenes, (s, i) => {
                        return (_openBlock(), _createBlock(_component_Scene, {
                          scene: s,
                          key: `default-scene-${i}`,
                          onEdit: ($event: any) => (_ctx.handleEditScene(s)),
                          onDelete: ($event: any) => (_ctx.toggleDeleteConfirm(s)),
                          onDisable: ($event: any) => (_ctx.toggleDisableConfirm(s)),
                          onDuplicate: ($event: any) => (_ctx.handleDuplicateScene(s)),
                          onEnable: ($event: any) => (_ctx.handleToggleEnabledScene(s)),
                          "disable-actions": !_ctx.scenesActionsEnabled
                        }, null, 8, ["scene", "onEdit", "onDelete", "onDisable", "onDuplicate", "onEnable", "disable-actions"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }),
      (_ctx.scenesAddSceneEnabled)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            onClick: _ctx.handleCreateScene,
            class: "p-button-rounded p-button-raised p-button--m ml-2 button-add-scene"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("plantDetail.addScene")), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_DialogConfirmDeleteScene, {
      "is-visible": _ctx.isVisibleDeleteConfirm,
      onHideDialog: _ctx.toggleDeleteConfirm,
      onConfirm: _ctx.handleDoDeleteScene,
      scene: _ctx.tempScene
    }, null, 8, ["is-visible", "onHideDialog", "onConfirm", "scene"]),
    _createVNode(_component_DialogConfirmDisableScene, {
      "is-visible": _ctx.isVisibleDisableConfirm,
      onHideDialog: _ctx.toggleDisableConfirm,
      onConfirm: _ctx.handleToggleEnabledScene,
      scene: _ctx.tempScene
    }, null, 8, ["is-visible", "onHideDialog", "onConfirm", "scene"])
  ], 64))
}